<app-tb-button *transloco="let t" (click)="openSearch()" [appearance]="'icon'" [icon]="'search'">
</app-tb-button>
